import { observer } from "mobx-react-lite";

import { useSportPartnersPageState } from "./page.state";
import { SportPartnersPageView } from "./page.view";

export const SportPartnersPage = observer(() => {
  const state = useSportPartnersPageState();
  return <SportPartnersPageView state={state} />;
});
